import { getDeviceType } from './getDeviceType';
import { isNative } from './isNative';

export const getValueForDevice = (value) => {
  if (typeof value === 'object') {
    if (isNative() && Object.prototype.hasOwnProperty.call(value, 'native')) {
      return value.native;
    }

    const device = getDeviceType();

    return value[device] || value.mobile || value;
  }

  return value;
};
